<template>
	<div class="container mt-5">
		
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Test | TankOn2'});
	},
	data: () => ({
		
	}),
	methods: {},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {},
}
</script>